import React, { PureComponent } from 'react';
import Header from '../components/DRHeader';
import Styles from '../constants/Styles';
// import { View, Text} from 'react-native';

import { env } from '../vodjs/settings';
import { DRButton } from '../components/DRControls';
import { getDeliveryType } from '../vodjs/lib';

// in the order we would like to display
const ORDERED_DAYS_OF_WEEK = {
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
  0: 'Sunday',
};
const ORDERED_DAYS_INDEX = [1, 2, 3, 4, 5, 6, 0];

/**
 * ServiceUnavailableScreen is used for blocking task requests outside of our hours of operation
 *  Behavior expected when it transitions from available to unavailable hours:
 *    1. no active/pending tasks are associated with the unit: we show the service unavailable screen without okay button (no escaping)
 *    2. active/pending tasks exist: we block the Send Moxi button by showing this service unavailable screen instead
 *  Behavior expected when it transitions from unavailable to available hours:
 *    This screen should auto-hide and allow the HomeScreen to show again such that the user can request tasks again
 */
export default class ServiceUnavailableScreen extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isServiceAvailable: props.isServiceAvailable,
      showButton: props.showButton !== undefined ? props.showButton : true,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextState) {
    if (nextProps.isServiceAvailable) this.props.closeModal();
  }

  render() {
    // TODO: move the delivery type to a constant file
    const serviceHoursText = {};  //env.siteConfig.getServiceHoursUserText(getDeliveryType());
    const dayToday = new Date(Date.now()).getDay(); // js library outputs 0-6 Sunday-Saturday

    const titleFont = {
      fontWeight: 400,
      fontSize: 25,
      numberOfLines: 1,
      alignSelf: 'center',
    };

    const serviceHoursFont = { fontSize: 20, numberOfLines: 1 };

    return (
      <div>
        <Header />
        <div style={{ width: 900, alignSelf: 'center', marginTop: 100 }}>
          <div style={titleFont}>Sorry, Moxi is unavailable at the moment.</div>
          <div style={titleFont}>Please check back during Moxi's operation hours.</div>
          <div style={{ ...titleFont, fontSize: 25, marginTop: 25 }}>Current hours of operation:</div>
          <div style={{ display: 'flex', flexDirection: 'column', marginTop: 25, marginLeft: 100 }}>
            {ORDERED_DAYS_INDEX.map((i) => {
              const day = ORDERED_DAYS_OF_WEEK[i];
              const leftStyle = dayToday == i ? { fontWeight: 'bold', fontSize: 20 } : { fontSize: 20 };
              const hours = serviceHoursText[day];
              const rightStyle = dayToday == i ? { ...serviceHoursFont, fontWeight: 'bold' } : serviceHoursFont;

              return (
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <div style={leftStyle}>{ORDERED_DAYS_OF_WEEK[i]}</div>
                  <div style={rightStyle}>{hours}</div>
                </div>
              );
            })}
          </div>
          <div style={{ fontSize: 20, marginTop: 25 }}>
            <div>Questions? Email us at </div>
            <div style={{ fontStyle: 'italic', color: '#2D9CA4' }}>feedback@diligentrobots.com</div>
          </div>
          {this.state.showButton && (
            <div style={{ marginTop: 70 }}>
              <DRButton
                action={() => this.props.closeModal()} // reason it is not this.props.closeModal is because the default param doesn't get passed in correctly otherwise
                fontColor={'#8785FF'}
                borderColor={'#8785FF'}
                phrase={'OKAY'}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

ServiceUnavailableScreen.navigationOptions = {
  header: null,
};

// Note: This is needed because publishing to expo runs minify, which changes the class names. In particular, classes
//       can end up with the same name which breaks the screen transition logic.
ServiceUnavailableScreen.viewName = 'ServiceUnavailableScreen';
